"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var table_options_1 = require("./table-options");
var table_row_type_1 = require("./table-row-type");
var row_option_1 = require("./row-option");
/**
 * Created by pavel.arakelyan on 11/13/17.
 */
var RowsRootView = /** @class */ (function () {
    function RowsRootView() {
        this._rowsCount = 0;
        this._showNew = false;
        this._dragEntered = false;
        this._rows = [];
    }
    Object.defineProperty(RowsRootView.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (value) {
            this._rows = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "rowsCount", {
        get: function () {
            return this._rowsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "showNew", {
        get: function () {
            return this._showNew;
        },
        set: function (value) {
            this._showNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "dragEntered", {
        get: function () {
            return this._dragEntered;
        },
        set: function (value) {
            this._dragEntered = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "beforeNewRowIndex", {
        get: function () {
            return this._beforeNewRowIndex;
        },
        set: function (value) {
            this._beforeNewRowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "afterNewRowIndex", {
        get: function () {
            return this._afterNewRowIndex;
        },
        set: function (value) {
            this._afterNewRowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "beforeCreatedRowIndex", {
        get: function () {
            return this._beforeCreatedRowIndex;
        },
        set: function (value) {
            this._beforeCreatedRowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "afterCreatedRowIndex", {
        get: function () {
            return this._afterCreatedRowIndex;
        },
        set: function (value) {
            this._afterCreatedRowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowsRootView.prototype, "justCreatedRowIndex", {
        get: function () {
            return this._justCreatedRowIndex;
        },
        set: function (value) {
            this._justCreatedRowIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    RowsRootView.prototype.getMaxDepth = function () {
        var max = 0;
        if (this.rows.length > 0) {
            this.rows.forEach(function (rows) {
                if (!rows.isRemoved) {
                    if (rows.collapsed) {
                        max = (max === 0 ? 1 : max);
                    }
                    else if (rows.getMaxDepth() > max) {
                        max = rows.getMaxDepth();
                    }
                }
            });
            return max;
        }
        else {
            return 0;
        }
    };
    RowsRootView.prototype.add = function (row) {
        row.parent = null;
        this._rows.push(row);
    };
    RowsRootView.prototype.remove = function (rowToRemove) {
        this._rows.splice(this._rows.findIndex(function (row) { return row === rowToRemove; }), 1);
    };
    RowsRootView.prototype.removeByCondition = function (predicate) {
        var _this = this;
        var indexToRemove = this._rows.findIndex(predicate);
        var removed = false;
        if (indexToRemove === -1) {
            removed = this._rows.some(function (child) {
                return _this.removeDeep(child, predicate);
            });
        }
        else {
            this._rows.splice(indexToRemove, 1);
            removed = true;
        }
        return removed;
    };
    RowsRootView.prototype.removeDeep = function (row, predicate) {
        var _this = this;
        return row.children.some(function (child) {
            var removed = false;
            var indexToRemove = row.children.findIndex(predicate);
            if (indexToRemove === -1) {
                removed = _this.removeDeep(child, predicate);
            }
            else {
                row.children.splice(indexToRemove, 1);
                removed = true;
            }
            return removed;
        });
    };
    RowsRootView.prototype.cleanCreatedRowIndexes = function () {
        this._justCreatedRowIndex = undefined;
        this._beforeCreatedRowIndex = undefined;
        this._afterCreatedRowIndex = undefined;
    };
    RowsRootView.prototype.setCreatedRowIndexes = function (index) {
        this._justCreatedRowIndex = index;
        this._beforeCreatedRowIndex = this.findPreviousVisibleElementIndex(index);
        this._afterCreatedRowIndex = this.findNextVisibleElementIndex(index);
    };
    RowsRootView.prototype.cleanNewRowIndexes = function () {
        this._beforeNewRowIndex = undefined;
        this._afterNewRowIndex = undefined;
    };
    RowsRootView.prototype.setIndexes = function (newRow) {
        this._rowsCount = 0;
        this.setIndexesRecursively(this._rows);
        if (newRow) {
            this._beforeNewRowIndex = this.findPreviousVisibleElementIndex(newRow.index);
            this._afterNewRowIndex = this.findNextVisibleElementIndex(newRow.index);
        }
        else {
            this._beforeNewRowIndex = undefined;
            this._afterNewRowIndex = undefined;
        }
    };
    RowsRootView.prototype.setIndexesRecursively = function (rows) {
        var _this = this;
        rows.forEach(function (row) {
            row.index = _this._rowsCount++;
            _this.setIndexesRecursively(row.children);
        });
    };
    RowsRootView.prototype.getCollapsedExpandedOptions = function () {
        var _this = this;
        var options = new table_options_1.TableOptions();
        this._rows.forEach(function (row) { return _this.getCollapseExpandRowOptions(row, options); });
        this._rows.forEach(function (row) { return _this.getRemovedRowOptions(row, options); });
        return options;
    };
    RowsRootView.prototype.getCollapseExpandRowOptions = function (rowView, options) {
        var _this = this;
        if (rowView.collapsed) {
            var fromIndex = rowView.index + 1;
            var toIndex = rowView.getLastNestedChildrenIndex();
            for (var index = fromIndex; index <= toIndex; index++) {
                options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.COLLAPSED));
            }
        }
        else {
            rowView.children.forEach(function (row) {
                options.add(row.index, new row_option_1.RowOption(table_row_type_1.TableRowType.EXPANDED));
                _this.getCollapseExpandRowOptions(row, options);
            });
        }
    };
    RowsRootView.prototype.getRemovedRowOptions = function (rowView, options) {
        var _this = this;
        if (rowView.isRemoved) {
            options.add(rowView.index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED));
            var fromIndex = rowView.index + 1;
            var toIndex = rowView.getLastNestedChildrenIndex();
            for (var index = fromIndex; index <= toIndex; index++) {
                options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED));
            }
        }
        else {
            rowView.children.forEach(function (row) {
                _this.getRemovedRowOptions(row, options);
            });
        }
    };
    RowsRootView.prototype.flatRows = function () {
        var _this = this;
        return this._rows.reduce(function (acc, row) {
            acc.push(row);
            acc = acc.concat(_this.flatChildren(row));
            return acc;
        }, []);
    };
    RowsRootView.prototype.flatChildren = function (row) {
        var _this = this;
        return row.children.reduce(function (acc, child) {
            acc = acc.concat(child);
            if (child.children.length) {
                acc = acc.concat(_this.flatChildren(child));
            }
            return acc;
        }, []);
    };
    RowsRootView.prototype.findPreviousVisibleElementIndex = function (index) {
        var rows = this.flatRows();
        var currentRowIndex = (index === this.rowsCount) ? index : rows.findIndex(function (value) { return value.index === index; });
        for (var i = currentRowIndex - 1; i >= 0; i--) {
            if (!rows[i].isRemoved && !rows[i].isHidden) {
                return rows[i].index;
            }
        }
        return -1;
    };
    RowsRootView.prototype.findNextVisibleElementIndex = function (index) {
        var rows = this.flatRows();
        var currentRowIndex = rows.findIndex(function (value) { return value.index === index; });
        for (var i = currentRowIndex + 1; i < rows.length; i++) {
            if (!rows[i].isRemoved && !rows[i].isHidden) {
                return rows[i].index;
            }
        }
        return this.rowsCount;
    };
    RowsRootView.prototype.getRowByIndex = function (index) {
        return this.flatRows().find(function (value) { return value.index === index; });
    };
    RowsRootView.prototype.setBeforeRemovedFlagOnPreviousSibling = function (row) {
        var children = row.parent ? row.parent.children : this.rows;
        var selfIndex = children.findIndex(function (value) { return value.index === row.index; });
        var isNeedToApplyFlag = !children.find(function (value) { return !value.isRemoved && value.index > row.index; });
        if (isNeedToApplyFlag) {
            for (var i = selfIndex - 1; i >= 0; i--) {
                if (!children[i].isRemoved) {
                    children[i].isBeforeRemoved = true;
                    break;
                }
            }
        }
    };
    /**
     * Clean removed elements and before-removed flags from rows tree
     */
    RowsRootView.prototype.cleanRemovedElements = function () {
        var _this = this;
        this.flatRows().forEach(function (rowView) {
            rowView.isBeforeRemoved = false;
            rowView.isParentRemoved = false;
            rowView.isRemovedParentCollapsed = false;
            if (rowView.isRemoved) {
                if (rowView.parent) {
                    rowView.parent.remove(rowView);
                }
                else {
                    _this.remove(rowView);
                }
            }
        });
        this.setIndexes();
    };
    RowsRootView.prototype.cleanHighlightRemoveFlags = function () {
        this.flatRows().forEach(function (rowView) {
            rowView.isGoingToRemove = false;
        });
    };
    RowsRootView.prototype.cleanShowNewFlags = function () {
        this.flatRows().forEach(function (rowView) {
            rowView.showNew = false;
        });
    };
    RowsRootView.prototype.cleanPrepareNewFlags = function () {
        this.flatRows().forEach(function (rowView) {
            rowView.prepareNew = false;
        });
    };
    RowsRootView.prototype.cleanSelectedFlags = function () {
        this.flatRows().forEach(function (rowView) {
            rowView.isSelected = false;
        });
    };
    RowsRootView.prototype.cleanExpandedFlags = function () {
        this.flatRows().forEach(function (rowView) {
            if (rowView.collapsed === false) {
                rowView.collapsed = undefined;
            }
        });
    };
    RowsRootView.prototype.cleanGoingToReplaceFlags = function () {
        this.flatRows().forEach(function (rowView) {
            rowView.isGoingToReplace = false;
        });
    };
    RowsRootView.prototype.getSelectedRow = function () {
        return this.flatRows().find(function (rowView) { return rowView.isSelected; });
    };
    RowsRootView.prototype.getUsedCategoryPathIds = function () {
        var pathIds = [];
        for (var i = 0; i < this.rows.length; i++) {
            var branchPathIds = this.rows[i].getUsedCategoryPathIdsInBranch();
            branchPathIds.forEach(function (pathId) {
                pathIds.push(pathId);
            });
        }
        return pathIds;
    };
    RowsRootView.prototype.getRowsInfo = function () {
        var rowsInfo = new Map();
        for (var i = 0; i < this.rows.length; i++) {
            this.setRowCategoryStyles(this.rows[i], rowsInfo);
        }
        return rowsInfo;
    };
    RowsRootView.prototype.setRowCategoryStyles = function (rowView, rowsInfo) {
        var _this = this;
        if (rowView) {
            rowsInfo.set(rowView.index, rowView.rowCategoryStyleDto);
            if (rowView.children.length !== 0) {
                rowView.children.forEach(function (child) {
                    _this.setRowCategoryStyles(child, rowsInfo);
                });
            }
        }
    };
    return RowsRootView;
}());
exports.RowsRootView = RowsRootView;
//# sourceMappingURL=rows-root-view.model.js.map